import React from "react";
import "./style.scss";

const SentSuccessfullyModal = ({title}) => {
    const className = "sent-successfully-modal";

    return (
        <div className={className}>
            <div className={`${className}--title`}>{title}</div>
        </div>
    );
}

export default SentSuccessfullyModal;
